// src/store/sku/sku.store.ts
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { SkuType } from "src/types/sku";

type SkuQueryState = {
  skuName: string;
  skuType: SkuType;
  page: number; // UI 1-based
  size: number;
  order: string;

  setQuery: (
    patch: Partial<Pick<SkuQueryState, "skuName" | "skuType" | "page" | "size" | "order">>
  ) => void;
  resetQuery: () => void;
};

const isDev = process.env.NODE_ENV === "development";

const DEFAULT: Pick<SkuQueryState, "skuName" | "skuType" | "page" | "size" | "order"> = {
  skuName: "",
  skuType: "PRODUCT",
  page: 1,
  size: 20,
  order: "createdAt,desc",
};

export const useSkuStore = create<SkuQueryState>()(
  devtools(
    (set) => ({
      ...DEFAULT,

      setQuery: (patch) =>
        set(
          (s) => ({
            ...s,
            ...patch,
          }),
          false,
          "sku/setQuery"
        ),

      resetQuery: () =>
        set(
          {
            ...DEFAULT,
          },
          false,
          "sku/resetQuery"
        ),
    }),
    { name: "sku-store", enabled: isDev }
  )
);

// selectors (원하면 파일 분리해도 됨)
export const useSkuName = () => useSkuStore((s) => s.skuName);
export const useSkuType = () => useSkuStore((s) => s.skuType);
export const useSkuPage = () => useSkuStore((s) => s.page);
export const useSkuSize = () => useSkuStore((s) => s.size);
export const useSkuOrder = () => useSkuStore((s) => s.order);

export const useSetSkuQuery = () => useSkuStore((s) => s.setQuery);
export const useResetSkuQuery = () => useSkuStore((s) => s.resetQuery);
